import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { wccBulkCreateApi } from './api';

export const useBulkCreate = () => {
  const [runBulkCreate, { data, isLoading, error, reset }] = wccBulkCreateApi.useRunBulkCreateMutation();

  const create = async (idList: number[]) => {
    if (idList.length === 0) return Promise.reject();
    return runBulkCreate(idList).unwrap();
  };

  const formattedReport = data ? {
    ...data,
    createdNumber: Array.isArray((data as any).successful) 
      ? (data as any).successful.length 
      : (data as any).createdNumber || (data as any).successfulCount || 0,
    failedNumber: Array.isArray((data as any).failed) 
      ? (data as any).failed.length 
      : (data as any).failedCount || 0,
    errorDetails: Array.isArray((data as any).failed) && (data as any).failed.length > 0
      ? (data as any).failed
        .map((f: any) => f.error || 'Неизвестная ошибка')
        .join('\n')
      : null
  } : null;

  return {
    create,
    report: formattedReport,
    loading: isLoading,
    error: extractNestJsErrorMessage(error),
    reset
  };
};
